import { Component, OnInit, Inject } from '@angular/core';
import { iDialogServiceInput } from '../dialog.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  public autocompleteOptions: { [key: number]: string[] } = {};

  public hours = Array.from(Array(24).keys()).map(addPadding);
  public minutes = Array.from(Array(60).keys()).map(addPadding);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: iDialogServiceData,
    private dialog: MatDialogRef<DialogComponent>
  ) {}

  ngOnInit() {
    if (this.data.inputs)
      this.data.inputs.forEach((input, index) => {
        if (input.type === 'time') {
          if (input.value) {
            input.value.h = addPadding(input.value.h) as any;
            input.value.m = addPadding(input.value.m) as any;
          } else input.value = { h: null, m: null };
        }

        if (input.type === 'autocomplete') this.autocompleteOptions[index] = input.enum;
      });
  }

  public changeAutocomplete(index: number, value: string) {
    const input = this.data.inputs[index];
    input.value = value;
    if (input.type === 'autocomplete')
      this.autocompleteOptions[index] = input.enum.filter(en => {
        if (value.includes(' ')) return en.startsWith(value);
        return en.split(' ').some(t => t.startsWith(value));
      });
  }

  public submit(ret: boolean | iDialogServiceInput[]) {
    this.dialog.close(ret);
  }
}

const addPadding = (num: number) => `0${num.toString()}`.substr(-2);

export interface iDialogServiceData {
  text: string;
  content?: string;
  buttonLabel: string;
  cancelLabel?: string;
  inputs?: iDialogServiceInput[];
}
